// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");

function view(param) {
  return {
          shape: param.shape,
          checkColor: param.checkColor
        };
}

var makeNewsletterZone_shape = Particle_Screen_Ds.make(undefined, undefined, undefined, {
      TAG: /* Square */2,
      _0: 20
    }, undefined, {
      TAG: /* Square */2,
      _0: 15
    });

var makeNewsletterZone = {
  shape: makeNewsletterZone_shape,
  checkColor: "White"
};

var makeFooter_shape = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      TAG: /* Square */2,
      _0: 15
    });

var makeFooter = {
  shape: makeFooter_shape,
  checkColor: "White"
};

var mona_shape = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      TAG: /* Square */2,
      _0: 16
    });

var mona = {
  shape: mona_shape,
  checkColor: "White"
};

var presse_shape = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      TAG: /* Square */2,
      _0: 16
    });

var presse = {
  shape: presse_shape,
  checkColor: "Black"
};

exports.view = view;
exports.makeNewsletterZone = makeNewsletterZone;
exports.makeFooter = makeFooter;
exports.mona = mona;
exports.presse = presse;
/* makeNewsletterZone Not a pure module */
